import { ChangeDetectorRef, Component, Inject, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { of, take } from 'rxjs';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSort, MatSortable } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AccountService } from '../../services/AccountService';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { XeroAccountAbstract } from '../../responses/xeroAllAccountsResponse';
import { XeroTrackingCategoryAbstract } from '../../responses/xeroAllTrackingCategoriesResponse';

@Component({ standalone:false,
  selector: 'app-xeroaccounts-dialog',
  templateUrl: 'xeroAccounts-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['xeroAccounts-dialog.component.scss']
})

export class XeroAccountsDialogComponent {
  @ViewChild ('tree') tree:any;
  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.accountsSort = ms;
    if(this.accountsSort) this.activeAccountsSort = {active:ms.active, direction:ms.start};
    this.setDataSourceAttributes();
  }
  
  public accountsSort?: MatSort;
  public title: string= "Xero";
  public confirmButtonText = "OK";

  public busyLoadingAccounts:boolean=false;
  public busyLoadingTrackingCategories:boolean=false;

  public activeAccountsSort?:{active:string, direction:string};
  public accountsFilterValue='';

  private _transformer = (node: TreeNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      level: level,
    };
  };
 
  public trackingCategoriesDataSource?:TreeNode[];

  public currentTabIndex:number=0;
    
  setDataSourceAttributes() {
    if(this._accountsDataSource){
      this.accountsSort?.sort(({ id: 'name', start: 'asc'}) as MatSortable);
      this._accountsDataSource.sort = this.accountsSort;
    }
  }

  private _accountsDataSource?: MatTableDataSource<XeroAccountAbstract>;


  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<XeroAccountsDialogComponent>, private accService:AccountService, private cd:ChangeDetectorRef) {
    if(data){
        this.title= this.title + " of '" + data.clientName + "'";
        if(data.customerId && data.clientId){
          this.busyLoadingAccounts=true;
          this.accService.getXeroAllAccounts(data.customerId,data.clientId).pipe(take(1)).subscribe(r=>{
            this.busyLoadingAccounts=false;
            this.cd.markForCheck();
            if(r.success) this.setAccountData(r.accountAbstracts);
          });
          this.busyLoadingTrackingCategories=true;
          this.accService.getXeroAllTrackingCategories(data.customerId,data.clientId).pipe(take(1)).subscribe(r=>{
            this.busyLoadingTrackingCategories=false;
            this.cd.markForCheck();
            if(r.success) this.setTrackingCategoryData(r.trackingCategoryAbstracts);
          });
        }
    }
  }

  ngAfterViewInit(){
    this.setDataSourceAttributes();
    this.cd.detectChanges();
  }

  get displayedAccountColumns() {
    return ['name', 'code', 'class', 'type'];
  }

  get accountsDataSource() {
    return this._accountsDataSource;
  }

  tabChanged(tabChangeEvent: MatTabChangeEvent){
    this.currentTabIndex=tabChangeEvent.index;
  }

  public accountSortChange($event:any){
    this.activeAccountsSort=$event;
  }
  
  public applyAccountsFilter(event: Event) {
    if(this._accountsDataSource){
      this.accountsFilterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
      this._accountsDataSource.filter = this.accountsFilterValue;
    }
  }

  private setAccountData(accountAbstracts:XeroAccountAbstract[]){
    this._accountsDataSource = new MatTableDataSource(accountAbstracts);
    this._accountsDataSource.sort = this.accountsSort;
    this._accountsDataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'name': return item.name;
        case 'code': return item.code; 
        case 'class': return item.accountClass;
        case 'type': return item.accountType;
        default: return '';
      }
    };
  }

  private setTrackingCategoryData(trackingCategories:XeroTrackingCategoryAbstract[]){
    //map data to treenode objects
    var treeData:TreeNode[]=[];
    trackingCategories.forEach(tc=>{
      var node = new TreeNode(tc.name);
      treeData.push(node);
      tc.trackingOptionAbstracts.forEach(to=>{
        node.children.push(new TreeNode(to.name));
      });
    });
    this.trackingCategoriesDataSource = treeData;
    this.cd.detectChanges();
    this.tree.expandAll();
  }

  childrenAccessor = (node: TreeNode) => node.children ?? [];
  hasChild = (_: number, node: TreeNode) => !!node.children && node.children.length>0;

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }

}

export class TreeNode {
  public children:TreeNode[]=[];
  constructor(public name:string){}
}